import "./closeFriend.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function CloseFriend({ user }) {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  // const [user, setUser] = useState({});
  // useEffect(() => {
  //   const fetchUser = async () => {
  //     const res = await axios.get(`/users?userId=${userId}`);
  //     setUser(res.data);
  //   };
  //   fetchUser();
  // }, [userId]);

  return (
    <Link
      to={"/profile/" + user.username}
      style={{ textDecoration: "none" }}
    >
      <li className="sidebarFriend">
        <img
          className="sidebarFriendImg"
          src={
            user.profilePicture
              ? PF + "person/" + user.profilePicture
              : PF + "person/no-avatar.png"
          }
          alt=""
        />
        <span className="sidebarFriendName">{user.username}</span>
      </li>
    </Link>
  );
}
